import { dataReportUser } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportUser = /*#__PURE__*/createIcon(dataReportUser)
export default IconReportUser
